import { AbilityBuilder } from "@casl/ability";
import { AppAbility } from "modules/auth";

export const defineRulesForCitizen = (abilityBuilder: AbilityBuilder<AppAbility>) => {
    const { can, cannot, rules } = abilityBuilder;

    cannot("view", "UserActivityModule");
    cannot("view", "UserAdministrationModule");
    cannot("view", "ModulesAdministrationModule");
    cannot("view", "CommunicationModule");
    can("view", "UserNotificationsModule");
    
    can("view", "InternalSystemsModule");
    can("view", "ExternalModules");
    can("view", "AdditionalModules");
    cannot("view", "EducationAnalysis");
    cannot("view", "SemisAdministrationModule");
    cannot("view", "SEMIS");
    cannot("view", "InternalDocumentation");
    cannot("view", "PIO");
    cannot("view", "Webtop");
    cannot("view", "ReportProblem");

    cannot("view", "Records");
    cannot("update", "Records");

    cannot("view", "EducationModule");
    cannot("view", "EducationLinks");
    cannot("view", "EducationDocuments");
    cannot("update", "EducationDocuments");

    can("view", "CourseList");

    cannot("view", "FarmList");
    cannot("update", "UserRole");

    cannot("view", "Beekeeping");
    cannot("update", "Beekeeping");

    return rules;
};
